export enum ExperienceReviewSubjectEnum {
    QUEST = 'quest',
    ROUTE = 'route',
}
